import { render, staticRenderFns } from "./app-screen-shot.vue?vue&type=template&id=040d32dc&"
import script from "./app-screen-shot.vue?vue&type=script&lang=js&"
export * from "./app-screen-shot.vue?vue&type=script&lang=js&"
import style0 from "./app-screen-shot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports